/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, 
         HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import * as models from '../model/models';
import { COLLECTION_FORMATS } from '../variables';
import { ApiConfiguration } from '../configuration';
import { PagedArray, LoggerService } from '../../common';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class AffiliateApi {
    protected basePath = '';
    public defaultHeaders: Record<string,string> = {};
    public configuration: ApiConfiguration = new ApiConfiguration();

    constructor(
        protected http: HttpClient, 
        @Optional() configuration: ApiConfiguration,
        protected logger: LoggerService
    ) {
        if (configuration) {
            this.configuration = configuration;
        }

        if (configuration && configuration.basePath)
            this.basePath = configuration.basePath;
    }

    private prepareResult<T>(result : Observable<HttpResponse<T>>) {
        return result.pipe(
            catchError(e => { // e has keys like _body,status,ok,statusText,headers,type,url
                if (e.status === 0 || e.status === 500 || e.status === 504) {
                    return throwError({
                        message: 'A network error has occurred.',
                        requestDetails: {
                            status: e.status,
                            statusText: e.statusText,
                            url: e.url,
                            headers: e.headers
                        },
                        error: true, 
                        errorType: 'network-error', 
                        json: function() { return this; }
                    });
                }
                return throwError(e);
            }),
            map(response => {
                if (response.status === 204)
                    return undefined;
                
                let result : any = response.body;

                if (typeof result === 'object') {
                    if (response.headers.get('X-TYT-Authentication'))
                        result['x-tyt-authentication'] = response.headers.get('X-TYT-Authentication')

                    if (result instanceof Array) {
                        if (response.headers.get('X-Total'))
                            result['total'] = Number(response.headers.get('X-Total'));
                        else if (response.headers.get('X-TYT-Total'))
                            result['total'] = Number(response.headers.get('X-TYT-Total'));
                    }
                }
                
                return result;
            })
        );
    }

    /**
     * Get affiliate&#39;s recent activity
     */
    public getActivity(__unused?: any): Observable<PagedArray<models.ApiTAPTransaction>> {
        return this.prepareResult(this.getActivityRequest(__unused));
    }

    /**
     * Update an affiliate
     * @param body 
     */
    public updateAffiliate(body?: models.ApiPatchUsersCurrentAffiliates, __unused?: any): Observable<models.ApiAffiliate> {
        return this.prepareResult(this.updateAffiliateRequest(body, __unused));
    }

    /**
     * Create an affiliate
     */
    public createAffiliate(__unused?: any): Observable<models.ApiAffiliate> {
        return this.prepareResult(this.createAffiliateRequest(__unused));
    }

    /**
     * Get a specific announcement
     * @param id 
     */
    public getAnnouncement(id?: string, __unused?: any): Observable<models.ApiAnnouncement> {
        return this.prepareResult(this.getAnnouncementRequest(id, __unused));
    }

    /**
     * Get the list of announcements
     * @param offset 
     * @param limit 
     */
    public getAnnouncements(offset?: number, limit?: number, __unused?: any): Observable<PagedArray<models.ApiAffiliateAnnouncement>> {
        return this.prepareResult(this.getAnnouncementsRequest(offset, limit, __unused));
    }

    /**
     * Get the affiliates leaderboard positions
     * @param period 
     */
    public getLeaderboard(period?: string, __unused?: any): Observable<PagedArray<models.ApiTAPLeaderboard>> {
        return this.prepareResult(this.getLeaderboardRequest(period, __unused));
    }

    /**
     * Get the affiliate community page data
     */
    public getCommunityPage(__unused?: any): Observable<models.ApiAffiliateCommunityPage> {
        return this.prepareResult(this.getCommunityPageRequest(__unused));
    }


    private applyGlobalHeaders(headers : Record<string,string>) {
        if (this.configuration.accessToken) {
            let accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        if (this.configuration.globalHeaders) {
            Object.keys(this.configuration.globalHeaders).forEach(key => {
                headers[key] = this.configuration.globalHeaders[key];
            })
        }
    }

    /**
     * 
     * 
     */
    public getActivityRequest(extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiTAPTransaction>>> {
        const path = this.basePath + '/users/current/affiliates/activity';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 

        this.applyGlobalHeaders(headers);


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiTAPTransaction>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;

                    if (e instanceof HttpErrorResponse) {
                        let error = <HttpErrorResponse>e;
                        this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${error.status} ${error.statusText}`);
                        e = error.error || e;
                    }

                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param body 
     */
    public updateAffiliateRequest(body?: models.ApiPatchUsersCurrentAffiliates, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiAffiliate>> {
        const path = this.basePath + '/users/current/affiliates';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 

        this.applyGlobalHeaders(headers);

        headers['Content-Type'] = 'application/json';


        let requestMethodStr = 'RequestMethod.Patch'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiAffiliate>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
                body: body == null ? '' : JSON.stringify(body), // https://github.com/angular/angular/issues/10612
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;

                    if (e instanceof HttpErrorResponse) {
                        let error = <HttpErrorResponse>e;
                        this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${error.status} ${error.statusText}`);
                        e = error.error || e;
                    }

                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public createAffiliateRequest(extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiAffiliate>> {
        const path = this.basePath + '/users/current/affiliates';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 

        this.applyGlobalHeaders(headers);


        let requestMethodStr = 'RequestMethod.Post'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiAffiliate>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;

                    if (e instanceof HttpErrorResponse) {
                        let error = <HttpErrorResponse>e;
                        this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${error.status} ${error.statusText}`);
                        e = error.error || e;
                    }

                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param id 
     */
    public getAnnouncementRequest(id?: string, extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiAnnouncement>> {
        const path = this.basePath + '/content/affiliate/announcements/{id}'
                    .replace('{' + 'id' + '}', String(id));

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 

        this.applyGlobalHeaders(headers);


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiAnnouncement>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;

                    if (e instanceof HttpErrorResponse) {
                        let error = <HttpErrorResponse>e;
                        this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${error.status} ${error.statusText}`);
                        e = error.error || e;
                    }

                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param offset 
     * @param limit 
     */
    public getAnnouncementsRequest(offset?: number, limit?: number, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiAffiliateAnnouncement>>> {
        const path = this.basePath + '/content/affiliate/announcements';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (offset !== undefined) {
            queryParameters['offset'] = <any>offset;
        }

        if (limit !== undefined) {
            queryParameters['limit'] = <any>limit;
        }


        this.applyGlobalHeaders(headers);


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiAffiliateAnnouncement>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;

                    if (e instanceof HttpErrorResponse) {
                        let error = <HttpErrorResponse>e;
                        this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${error.status} ${error.statusText}`);
                        e = error.error || e;
                    }

                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     * @param period 
     */
    public getLeaderboardRequest(period?: string, extraHttpRequestParams?: any): Observable<HttpResponse<PagedArray<models.ApiTAPLeaderboard>>> {
        const path = this.basePath + '/affiliates/leaderboard';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 
        if (period !== undefined) {
            queryParameters['period'] = <any>period;
        }


        this.applyGlobalHeaders(headers);


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<PagedArray<models.ApiTAPLeaderboard>>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;

                    if (e instanceof HttpErrorResponse) {
                        let error = <HttpErrorResponse>e;
                        this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${error.status} ${error.statusText}`);
                        e = error.error || e;
                    }

                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

    /**
     * 
     * 
     */
    public getCommunityPageRequest(extraHttpRequestParams?: any): Observable<HttpResponse<models.ApiAffiliateCommunityPage>> {
        const path = this.basePath + '/affiliates/community';

        let traceStart = Date.now();
        let queryParameters : Record<string,string> = {};

        let globalQueryParams = (this.configuration.globalQueryParams || {});
        Object.keys(globalQueryParams).forEach (x => queryParameters[x] = globalQueryParams[x]);
        
        let headers : Record<string,string> = Object.assign({}, this.defaultHeaders); 

        this.applyGlobalHeaders(headers);


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;
        let authState = '';

        if (Object.keys(queryParameters).length > 0) {
            requestPath = `${requestPath}?${Object.keys(queryParameters)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParameters[key])}`).join('&')}`;
        }

        if (this.configuration.accessToken) 
            authState = `(authenticated) `;
        
        return this.http
            .request<models.ApiAffiliateCommunityPage>(requestMethodStr, requestPath, { 
                observe: 'response', 
                responseType: 'json',
                headers, 
                withCredentials: this.configuration.withCredentials,
            })
            .pipe(
                catchError(e => {
                    let time = Date.now() - traceStart;

                    if (e instanceof HttpErrorResponse) {
                        let error = <HttpErrorResponse>e;
                        this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Error: ${error.status} ${error.statusText}`);
                        e = error.error || e;
                    }

                    return throwError(e);
                }),
                map(response => {
                    let time = Date.now() - traceStart;
                    this.logger.info(`[API] ${requestMethodStr} ${authState}${requestPath} (${time} ms): Finished: ${response.status} ${response.statusText}`);

                    return response;
                })
            )
        ;
    }

}
